<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false"
           @on-ok="ok" :loading="loading" @on-cancel="cancel"
           :width="650"
    >
      <h3 slot="header" class="modal-header">企业交割</h3>
      <Table :columns="columns" :data="data"></Table>
      <delivery-input-person :n="n1"
                             :contractId="contractId"
                             :stockFid="stockFid"
                             @done="getParentDeliveryState(true)"
                             :projectName="projectName"
                             :stockNumber="stockNumber"
                             :mask="true"

      ></delivery-input-person>
      <delivery-update
        :n="n2"
        :contractId="contractId"
        :stockFid="stockFid"
        @done="getParentDeliveryState(false)"
        :projectName="projectName"
        :stockNumber="stockNumber"
        :mask="true"
      ></delivery-update>
    </Modal>
  </div>
</template>
<script>
  import {getParentDeliveryState} from "../../../../api/contractList";
  import DeliveryInputPerson from './DeliveryInputPerson';
  import DeliveryUpdate from './DeliveryUpdate'
  export default {
    name: "DeliveryInputBusin"  ,
    components:{
      DeliveryInputPerson,
      DeliveryUpdate
    },
    props:{
      projectName:{
        type: String,
        default: ''
      },
      // stockFid:{
      //   type:String,
      //   default:''
      // },
      n: {
        type: Number,
        default: 0
      },
      parentContractFid: {
        type: String,
        default: null
      },
    },
    watch:{
      n(){
        this.data=[]
        this.getParentDeliveryState(false)
        this.isShow=true
      }
    },
    data(){
      return {
        n2:0,
        stockFid:'',
        stockNumber:'',
        contractId:'',
        n1:0,
        data:[],
        loading: true,
        isShow:false,
        columns:[
          {
            title: "房间号",
            key: "stockNumber",
            align: "center"
          },
          {
            title: "交割状态",
            key: "deliveryStateCn",
            align: "center"
          },
          {
            title: "操作",
            key: "action",
            align: "center",
            render:(h,params)=>{
              let input=h('a',{
                on:{
                  click:()=>{
                    this.contractId=params.row['contractFid']
                    this.stockNumber=params.row['stockNumber']
                    this.stockFid=params.row['stockFid']
                    this.n1++
                  }
                },
              },'录入交割')

              let update=h('a',{
                on:{
                  click:()=>{
                    this.contractId=params.row['contractFid']
                    this.stockNumber=params.row['stockNumber']
                    this.stockFid=params.row['stockFid']
                    this.n2++
                  }
                },
              },'修改交割')
              return params.row['deliveryState']===0?input:update
            }
          },
        ]
      }
    },
    methods:{
      getParentDeliveryState(bool){
        if(!this.parentContractFid){
          return
        }
        let params={
          parentContractFid:this.parentContractFid
        }
        getParentDeliveryState(params).then(res=>{
          this.data=res.data
          if(bool){
            for(let i=0,len=this.data.length;i<len;i++){
              if(this.data[i].deliveryState===0){
                let data1=this.data[i]

                this.contractId=data1['contractFid']
                this.stockNumber=data1['stockNumber']
                this.stockFid=data1['stockFid']
                this.n1++
                break
              }
            }
          }

        }).catch(error=>{
          this.data=[{test:1}]
        })


      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
        this.$emit('done')
        this.isShow=false
      },
      cancel(){

      }
    }

  }
</script>

<style scoped>

</style>
